<template>
  <div>
    <div class="ibox">
      <div class="ibox-title">
        <h5>Profiles Portal URL</h5>
      </div>
      <div class="ibox-content ibox-heading">
        Generate URL for profiles portal service
      </div>

      <div class="ibox-content">
        <el-form ref="form" label-width="158px">
          <el-form-item v-if="generateUrlSuccess" label="Generated Url">
            <div class="copy-input">
              <el-input v-model="generatedUrl" readonly></el-input>
              <el-button class="copy-button" type="text" @click="copyUrl" icon="el-icon-document-copy"></el-button>
            </div>
          </el-form-item>

          <el-form-item label="Generate URL" prefix-icon="el-icon-refresh">
            <el-button :loading="loadingGenerateUrl"
              :disabled="generateUrlSuccess"
              type="primary"
              @click="generate" plain>Generate</el-button>
          </el-form-item>

        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag';

export default {
  name: 'GeneratePermissionURL',
  data() {
    return {
      loadingGenerateUrl: false,
      generateUrlSuccess: false,
      generatedUrl: '',
    };
  },
  methods: {
    generate() {
      this.loadingGenerateUrl = true;
      this.$apollo.mutate({
        client: 'apiv2',
        mutation: gql`
          mutation {
            generatePermissionProfileUrl
        }`,
      })
      .then(results => {
        this.generatedUrl = results.data.generatePermissionProfileUrl.url;
        this.generateUrlSuccess = true;
        this.loadingGenerateUrl = false;
      })
      .catch(() => {
        this.loadingGenerateUrl = false;
        this.generateUrlSuccess = false;
        this.$notify({
          title: 'Error',
          message: 'Failed to generate URL',
          type: 'error',
        });
      });
    },
    async copyUrl() {
      const input = this.$refs.form.$el.querySelector('.el-input__inner');
      input.select();
      try {
        await navigator.clipboard.writeText(input.value);
        this.$notify({
          title: 'Success',
          message: 'URL copied to clipboard',
          type: 'success',
        });
      } catch (err) {
        this.$notify({
          title: 'Error',
          message: 'Failed to copy URL to clipboard',
          type: 'error',
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.copy-input {
  position: relative;
}
.copy-button {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
}
</style>



// WEBPACK FOOTER //
// GeneratePermissionURL.vue?6564be10